module.exports = __webpack_public_path__ + "static/media/colnomina.50e7870b.png";